import './CoralLandscapeImage.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { mapCoralWebLandscapeImage } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

type CoralLandscapeImageProps = ReturnType<typeof mapCoralWebLandscapeImage>

export const CoralLandscapeImage: FC<CoralLandscapeImageProps> = ({ image }) => {
  return (
    <Asset className={'coral-landscape-image'} objectFit={'cover'} thumbnail={image?.thumbnail} />
  )
}
